import envConfig from "@/config/envConfig";

export const getImageUrl = (url: string) => {
  if (!url) return "";
  else if (url?.includes("/api/media")) {
    return envConfig.imgStoreUrl + "/" + url.split("file/").at(1);
  } else if (url?.includes("/media")) {
    return envConfig.imgStoreUrl + "/" + url?.split("/")[2];
  } else return envConfig.imgStoreUrl + (url?.startsWith("/") ? "" : "/") + url;
};
